// src/app/panel-mode.ts
import { useSyncExternalStore } from "react";

/** الوضع الحالي للحساب "الهجين" (له مشاريعه الخاصة + أدمن منصة كمان): أي لوحة يشوف الآن. */
export type PanelMode = "projects" | "platform";

const KEY = "adman.panelMode";
const listeners = new Set<() => void>();

const read = () => localStorage.getItem(KEY) as PanelMode | null;
const subscribe = (l: () => void) => (listeners.add(l), () => void listeners.delete(l));

export function setPanelMode(mode: PanelMode) {
  localStorage.setItem(KEY, mode);
  listeners.forEach((l) => l());
}

/** لحساب مش هجين (منصة بس أو مشاريع بس) الوضع دايماً ثابت ومفيش سويتش أصلاً. */
export function usePanelMode(defaultMode: PanelMode): PanelMode {
  const stored = useSyncExternalStore(subscribe, read);
  return stored ?? defaultMode;
}
